






import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import ProductResourceHelperComponents4ProductResourceItem from './product-resource-helper-components-4-product-resource-item.vue'

@Component({
  components: {
    ProductResourceHelperComponents4ProductResourceItem
  }
})
class ProductResourceHelperComponents3ResourceList extends Vue {
  @Prop({ default: '' }) productResourceId?: string
  @Prop({ default: false }) isPublicAccountViewing?: boolean
}

export default ProductResourceHelperComponents3ResourceList

